module.exports = __webpack_public_path__ + "static/media/49.3d3f6316.png";